import { useSendOtp, useVerifyOtp } from './requests'

export const useAuthApi = () => {
  const sendOtpApi = useSendOtp()
  const verifyOtpApi = useVerifyOtp()

  return { sendOtpApi, verifyOtpApi }
}
